import { Chip } from "@mui/material";
import Grid from "@mui/material/Grid";
import { CSSProperties } from "react";
import styled from "styled-components";

export const AppRoot = styled.div`
  display: flex;
  min-height: 100vh;
  width: 100%;
  flex-direction: column;
  margin: 0px;
  padding: 0px;
` as any;

export const AppContent = styled.div`
  flex: 1;
  width: 100%;
  min-heigth: 12rem;
  border: tpx solid green;
` as any;

export const Stack = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
` as any;

export const StackStrechChild = styled.div`
  flex: 1;
`;

export const SidebarTitle = styled.p`
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 25px;
  line-height: 25px;
  padding: 0px;
  margin: 0px;
`;

export const ResponsiveCenter = ({ children }: any) => (
  <Grid tabIndex={-1} container spacing={0} alignItems="center" justifyContent="center">
    <Grid tabIndex={-1} item xs={12} sm={12} md={10} xl={9}>
      {children}
    </Grid>
  </Grid>
);

export const Aligned = (props: { style?: CSSProperties; children: any; onClick?: any }) => (
  <div
    style={{ display: "flex", justifyContent: "start", alignItems: "center", ...(props.style || {}) }}
    onClick={props.onClick}
  >
    {props.children}
  </div>
);

export const FullSizeAligned = (props: { style?: CSSProperties; children: any }) => (
  <div
    style={{
      display: "flex",
      justifyContent: "start",
      alignItems: "center",
      width: "100%",
      height: "100%",
      ...(props.style || {}),
    }}
  >
    {props.children}
  </div>
);

export const VerticalSpacer = styled.div<{ height?: string }>`
  height: ${(props) => (props.height ? props.height : "8px")};
`;

export const OverflowDiv = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
`;

export const Shortcut = styled.p`
  font-family: "Roboto", sans-serif;
  font-size: 13px;
  background-color: #eeeeee;
  border-radius: 4px;
  padding: 8px;
  margin: 6px;
  min-width: 25px;
  height: 25px;
  text-align: center;
`;

export const StyledChip = styled(Chip)`
  display: flex;
  padding: 8px 9px;
  justify-content: center;
  align-items: center;
  gap: 6px;
  border-radius: 1px;
  background: var(--neutral-200, #eee);
`;

export const HiddenChip = styled(Chip)`
  background-color: #f0f0f0;
  color: #999999;
  height: 20px;
  padding: 0 1px;
`;

export const HiddenChip2 = styled(Chip)`
  background-color: #414141;
  color: #999999;
  height: 20px;
  padding: 0 1px;
`;
